import { Injectable } from '@angular/core';
import { ServiceAgreement } from './../models/service-agreement.model';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ServiceAgreementService {
  headers = {
    'Content-Type': 'application/json'
  };

  constructor(private http: HttpClient) { }

  submitServiceAgreement(serviceAgreement: ServiceAgreement) {
    return this.http.post(environment.apiUrl + '/service-agreements', serviceAgreement, {
      responseType: 'json',
      observe: 'body',
      headers: this.headers,
    });
  }

}
